import script from "./AccountFormList.vue?vue&type=script&setup=true&lang=js"
export * from "./AccountFormList.vue?vue&type=script&setup=true&lang=js"

import "./AccountFormList.vue?vue&type=style&index=0&id=687c6194&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-687c6194"]])

export default __exports__